/* eslint-disable react/button-has-type */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Power, Pencil, PowerOff } from "lucide-react";
import DeactivateClientModal from '../../../clientAdmin/modals/DeactivateClientModal';

export default function ClientInfo({ clientDetails, onEdit, isActive, onDeactivate, learnerCount, deactivating }) {
  const [showModal, setShowModal] = useState(false);

    const handleConfirm = (reason) => {
    onDeactivate(reason);
    setShowModal(false);
    };
  return (
  
    <div className="mt-4 space-y-6 text-sm">
      <div className="flex gap-3 mb-4">
    <button onClick={onEdit} className="flex items-center gap-2 border px-4 py-2 rounded-md text-sm text-gray-700 bg-white hover:bg-gray-50">
        <Pencil size={16}/> Edit Details
    </button>
    {isActive ? (
        <button
            onClick={() => setShowModal(true)}
            disabled={deactivating}
            className="flex items-center gap-2 border px-4 py-2 rounded-md text-sm text-red-600 border-red-200 bg-white hover:bg-red-50 disabled:opacity-50 disabled:cursor-not-allowed"
        >
            {deactivating
                ? <span className="w-4 h-4 border-2 border-red-300 border-t-red-600 rounded-full animate-spin"/>
                : <PowerOff size={16}/>
            }
            {deactivating ? 'Processing...' : 'Deactivate'}
        </button>
    ) : (
        <button
            onClick={() => setShowModal(true)}
            disabled={deactivating}
            className="flex items-center gap-2 border px-4 py-2 rounded-md text-sm text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
            {deactivating
                ? <span className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin"/>
                : <Power size={18}/>
            }
            {deactivating ? 'Processing...' : 'Reactivate'}
        </button>
    )}
</div>
       {showModal && (
        <DeactivateClientModal
          clientDetails={clientDetails}
          isActive={isActive}
          onConfirm={handleConfirm}
          onCancel={() => setShowModal(false)}
          loading={deactivating}
        />
      )}

      {/* TOP SECTION */}
      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-9 bg-white border border-gray-200 rounded-xl shadow-sm p-6">
          <div className="flex justify-between items-start mb-4">
            <h2 className="text-sm font-semibold text-gray-800">
              Client Admin Details
            </h2>

          </div>
          <div className="grid grid-cols-12 gap-y-4">

            {/* Name */}
            <div className="col-span-3 text-gray-500">Client Name</div>
            <div className="col-span-9 font-medium">
              {clientDetails?.organizationName}
            </div>

            {/* Type */}
            <div className="col-span-3 text-gray-500">Type</div>
            <div className="col-span-9">
              <span className="px-2 py-1 text-xs rounded bg-blue-100 text-blue-600">
                {clientDetails?.type || 'B2B'}
              </span>
            </div>

            {/* Feature Mode */}
            <div className="col-span-3 text-gray-500">Feature Mode</div>
            <div className="col-span-9">
              <span className={`px-2 py-1 text-xs rounded ${clientDetails?.featureToggleMode === 'FULL_CREATOR'
                ? 'bg-blue-100 text-blue-600'
                : 'bg-gray-100 text-gray-600'
                }`}>
                {clientDetails?.featureToggleMode === 'FULL_CREATOR' ? 'Full Creator' : 'Run Only'}
              </span>
            </div>

            {/* Status */}
            <div className="col-span-3 text-gray-500">Status</div>
            <div className="col-span-9">
              <span className={`px-2 py-1 text-xs rounded ${isActive ? 'bg-green-100 text-green-600' : 'bg-gray-100 text-gray-500'}`}>
                {isActive ? 'Active' : 'Inactive'}
              </span>
            </div>

            {/* Created */}
            <div className="col-span-3 text-gray-500">Created</div>
            <div className="col-span-9">
              {clientDetails?.createdDate
                ? new Date(clientDetails.createdDate).toLocaleDateString()
                : '-'}
            </div>

            <div className="col-span-3 text-gray-500">Client Admin</div>
            <div className="col-span-9">
              <div className="font-medium flex items-center gap-2">
                {clientDetails?.clientAdmin?.fullName}
                <span className={`w-2 h-2 rounded-full flex-shrink-0 -translate-y-1.5 ${clientDetails?.clientAdmin?.status === 'ACTIVE' ? 'bg-green-500' : 'bg-red-400'
                  }`} />
              </div>
              <span className="truncate block max-w-full" title={clientDetails?.clientAdmin?.email}>
                {clientDetails?.clientAdmin?.email}
              </span>
            </div>
          </div>
        </div>

        {/* RIGHT CARD */}
        <div className="col-span-3 bg-white border border-gray-200 rounded-xl shadow-sm p-6">
          <h2 className="text-sm font-semibold text-gray-800 mb-4">
            Seat Usage
          </h2>

          <div className="text-2xl font-semibold text-gray-900">
            {clientDetails?.learnersCount ?? '—'} <span className="text-gray-400 text-lg">/ {clientDetails?.learnerSeats ?? '—'}</span>
          </div>

          <div className="text-xs text-gray-500 mt-2">
            Active learners
          </div>
        </div>
      </div>

      {/* CONTACT + ADDRESS */}
      <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-6 mt-6">
        <h2 className="text-sm font-semibold text-gray-800 mb-4">Contact & Address</h2>

        <div className="grid grid-cols-2 gap-x-12 gap-y-3 text-sm">
          {/* Left column */}
          <div className="space-y-3">
            <div className="grid grid-cols-2">
              <span className="text-gray-500">Contact Name</span>
              <span>{clientDetails?.contactName}</span>
            </div>
            <div className="grid grid-cols-2">
              <span className="text-gray-500">Contact Email</span>
              <div className="text-gray-500 text-xs truncate max-w-full" title={clientDetails?.contactEmail}>
                {clientDetails?.contactEmail}
              </div>
            </div>
            <div className="grid grid-cols-2">
              <span className="text-gray-500">Contact Phone</span>
              <span>{clientDetails?.contactPhone}</span>
            </div>
            <div className="grid grid-cols-2">
              <span className="text-gray-500">Timezone</span>
              <span>{clientDetails?.timeZone?.description}</span>
            </div>
            <div className="grid grid-cols-2">
              <span className="text-gray-500">Date Format</span>
              <span>{clientDetails?.dateFormat?.description}</span>
            </div>
          </div>

          {/* Right column */}
          <div className="space-y-3">
            <div className="grid grid-cols-2">
              <span className="text-gray-500">Address Line 1</span>
              <span>{clientDetails?.address1}</span>
            </div>
            <div className="grid grid-cols-2">
              <span className="text-gray-500">Address Line 2</span>
              <span>{clientDetails?.address2}</span>
            </div>
            <div className="grid grid-cols-2">
              <span className="text-gray-500">City</span>
              <span>{clientDetails?.city}</span>
            </div>
            <div className="grid grid-cols-2">
              <span className="text-gray-500">State</span>
              <span>{clientDetails?.state?.description}</span>
            </div>
            <div className="grid grid-cols-2">
              <span className="text-gray-500">Country</span>
              <span>{clientDetails?.country?.description}</span>
            </div>
            <div className="grid grid-cols-2">
              <span className="text-gray-500">Zip Code</span>
              <span>{clientDetails?.zipCode}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}